(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ti-button-shape"] && !Shopify.designMode) return;
  try {
    (() => {
  const selector = '.button:not(.button--close):not(.button--icon):not(.button--circle):not(.self-button):not(.pointer-events-auto:not(.ti-button-shape)):not(.quick-view__button):not(.indicators .button)';
  const tracked = new WeakSet();
  const draw = (button) => {
    if (!button.matches('a, button')) return;
    const style = getComputedStyle(button);
    const cut = parseFloat(style.getPropertyValue('--ti-global-button-cut')) || 0;
    if (!cut) return;
    const width = button.clientWidth, height = button.clientHeight;
    if (!width || !height) return;
    const border = parseFloat(style.getPropertyValue('--buttons-border-width')) || 1;
    const inset = border / 2;
    const right = width - inset, bottom = height - inset;
    const radius = Math.max(0, Math.min(parseFloat(style.borderTopLeftRadius) || 0, height / 2, width / 2) - inset);
    const softness = Math.min(Number(document.documentElement.dataset.tiButtonSoftness || 3), cut / 4);
    const tangent = softness * Math.SQRT1_2;
    const x = width - cut + inset - border * Math.SQRT1_2;
    const y = cut - inset + border * Math.SQRT1_2;
    let svg = button.querySelector(':scope > .ti-button-outline');
    if (!svg) {
      svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('class', 'ti-button-outline');
      svg.setAttribute('aria-hidden', 'true');
      svg.appendChild(document.createElementNS(svg.namespaceURI, 'path'));
      button.appendChild(svg);
    }
    svg.setAttribute('viewBox', `0 0 ${width} ${height}`);
    svg.firstElementChild.setAttribute('stroke-width', border);
    svg.firstElementChild.setAttribute('d', `M ${inset + radius} ${inset} H ${x - softness} Q ${x} ${inset} ${x + tangent} ${inset + tangent} L ${right - tangent} ${y - tangent} Q ${right} ${y} ${right} ${y + softness} V ${bottom - radius} Q ${right} ${bottom} ${right - radius} ${bottom} H ${inset + radius} Q ${inset} ${bottom} ${inset} ${bottom - radius} V ${inset + radius} Q ${inset} ${inset} ${inset + radius} ${inset} Z`);
    button.setAttribute('data-ti-outline-ready', '');
  };
  const resize = new ResizeObserver(entries => entries.forEach(entry => {
    if (entry.target.isConnected) draw(entry.target);
    else resize.unobserve(entry.target);
  }));
  const scan = () => document.querySelectorAll(selector).forEach(button => {
    if (!tracked.has(button)) {
      tracked.add(button);
      resize.observe(button);
      draw(button);
    }
  });
  scan();
  new MutationObserver(records => {
    if (records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && !node.matches?.('.ti-button-outline, .ti-button-outline *')))) scan();
  }).observe(document.body, { childList: true, subtree: true });
})();
  } catch(e) { console.error(e); }
})();

})();
